import { format, parseISO } from "date-fns";
import React from "react";
import { RenderResultObject } from "types/table.types";

export const formatMoney = (value: string): string => {
  const numericValue = value.replace(/[^\d.]/g, '');
  if (!numericValue) return '0';
  const [intPart, decimalPart] = numericValue.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
};
export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('en-US').format(price);
};
export const getRegion = () => {
  const region = process.env.REACT_APP_REGION;
  if (!region) throw new Error('Missing REGION env variable');
  return region;
};
export const getImageUploadBucket = () => {
  const bucket = process.env.REACT_APP_IMAGE_UPLOAD_BUCKET;
  if (!bucket) throw new Error('Missing IMAGE_UPLOAD_BUCKET env variable');
  return bucket;
};
export const getFilePath = () => {
  return `https://${getImageUploadBucket()}.s3.${getRegion()}.amazonaws.com`;
};

export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return "-";

  try {
    const dateObj = typeof date === "string" ? parseISO(date) : date;
    if (isNaN(dateObj.getTime())) {
      return "-";
    }
    return format(dateObj, "HH:mm 'Ngày' dd/MM/yyyy");
  } catch (error) {
    console.error("Error formatting date:", error);
    return "-";
  }
};

  export const isLate = (value: string | undefined) => {
    if (!value) return false;
    const today = new Date();
    const estimated = new Date(value);
    return estimated < today;
  };
export const removeUndefined = <T extends object>(obj: T): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>;
};

export const isUUID = (value?: string): boolean => {
  if (!value) return false;

  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
    value.toLowerCase()
  );
};
export const isRenderResultObject =(
  value: unknown,
): value is RenderResultObject => {
  return (
    typeof value === "object" &&
    value !== null &&
    !React.isValidElement(value) &&
    "children" in value
  );
}